// extracted by mini-css-extract-plugin
export var activeFilterButton = "_p8-c";
export var backButton = "_p8-4";
export var backIcon = "_p8-5";
export var chevronShortcut = "_p8-6";
export var container = "_p8-1";
export var editor = "_p8-8";
export var editorWrapper = "_p8-7";
export var prefix = "_p8-2";
export var searchIcon = "_p8-3";
export var suffix = "_p8-9";
export var suffixContent = "_p8-a";
export var suffixText = "_p8-b";
export var wrapper = "_p8-0";